<template>
  <div class="select-filter" :class="{ filter__disabled: disabled }">
    <div class="select-filter__wrapper" @click="toggleDropdown">
      <label class="select-filter__label">{{ title }}</label>
      <img src="@/assets/select_filter_arrow.svg" alt="arrow" />
    </div>
    <div v-if="isOpen" class="custom-dropdown">
      <div class="search-wrapper">
        <input
          type="text"
          v-model="searchQuery"
          :placeholder="$t('monitoring.enter_id')"
          class="search-input"
          @click.stop
        />
        <img
          src="@/assets/x-close.svg"
          alt="x"
          @click.stop="clearSearch"
          v-show="searchQuery"
          class="x-close"
        />
      </div>
      <div class="options-list">
        <div
          v-for="(option, index) in sortedOptions"
          :key="option.value"
          class="option-item"
          :class="{
            selected: isSelected(option.value),
            'last-selected':
              isSelected(option.value) && index === selectedCount - 1,
          }"
          @click.stop="toggleOption(option)"
        >
          <img
            class="checkbox"
            :src="
              isSelected(option.value)
                ? require('@/assets/checkbox.svg')
                : require('@/assets/checkbox_empty.svg')
            "
            alt="checkbox"
          />
          <span class="option-text">{{ option.name }}</span>
        </div>

        <div v-if="filteredOptions.length === 0" class="empty-message">
          {{ $t("monitoring.no_matching_id") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectFilterHubs",
  props: {
    title: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: "hub_ids",
    },
    disabled: Boolean,
  },
  data() {
    return {
      isOpen: false,
      searchQuery: "",
    };
  },
  computed: {
    hubOptions() {
      const uniqueItems = this.items.reduce((acc, item) => {
        if (!acc.some((existing) => existing.id === item.id)) {
          acc.push(item);
        }
        return acc;
      }, []);

      return uniqueItems.map((item) => ({
        value: item.id,
        name: String(item.id),
        checked: this.selectedHubIds.includes(item.id),
      }));
    },
    filteredOptions() {
      return this.hubOptions.filter((option) =>
        option.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    sortedOptions() {
      const selected = [];
      const unselected = [];

      this.filteredOptions.forEach((option) => {
        this.isSelected(option.value)
          ? selected.push(option)
          : unselected.push(option);
      });

      return [...selected, ...unselected];
    },
    selectedCount() {
      return this.sortedOptions.filter((option) =>
        this.isSelected(option.value)
      ).length;
    },
    unselectedCount() {
      return this.sortedOptions.length - this.selectedCount;
    },
    selectedHubIds() {
      return this.$store.getters.SELECTED_FILTERS[this.name] || [];
    },
    selectedHubs() {
      return this.selectedHubIds.map((id) => ({
        value: id,
        name: id.toString(),
        checked: true,
      }));
    },
  },
  methods: {
    toggleDropdown() {
      if (this.disabled) return;
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.searchQuery = "";
      }
    },
    clearSearch() {
      this.searchQuery = "";
    },

    toggleOption(option) {
      const newValues = this.selectedHubIds.includes(option.value)
        ? this.selectedHubIds.filter((id) => id !== option.value)
        : [...this.selectedHubIds, option.value];

      this.$store.dispatch("set_filters", {
        name: this.name,
        value: newValues,
      });
    },
    isSelected(value) {
      return this.selectedHubIds.includes(value);
    },
    apply_filter() {},
    clickOutsideHandler(e) {
      if (this.isOpen && !this.$el.contains(e.target)) {
        this.isOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.clickOutsideHandler);
    this.$parent.$on("apply_filter", this.apply_filter);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.clickOutsideHandler);
  },
};
</script>

<style scoped>
@font-face {
  font-family: Effra;
  src: url("../../fonts/Effra_regular.otf") format("opentype"),
    url("../../fonts/Effra_Std_Rg.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
.select-filter {
  position: relative;
  margin-right: 20px;
}

.select-filter__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #1f2120;
}

.select-filter__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  cursor: pointer;
}

.select-filter__input-display {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.select-filter__placeholder {
  color: #9e9e9e;
  font-size: 14px;
}

.select-filter__selected-values {
  color: #1f2120;
  font-size: 14px;
}

.select-filter__arrow {
  width: 12px;
  height: 12px;
  margin-left: 8px;
  transition: transform 0.3s;
}

.select-filter__arrow.open {
  transform: rotate(180deg);
}

.custom-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 236px;
  background: white;
  border: 1px solid #c4c4c4;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(39, 87, 255, 0.5);
  z-index: 1000;
  padding: 2px 2px;
}

.search-wrapper {
  padding: 0 0 8px;
  position: relative;
}

.search-input {
  width: 100%;
  box-sizing: border-box;
  padding: 6px 10px;
  border: none;
  border-radius: 4px;
  background-color: #f5f5f5;
  height: 44px;
  font-family: Effra;
  font-size: 16px;
  padding-right: 36px;
}

.options-list {
  max-height: 160px;
  overflow-y: auto;
}

.option-item {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  cursor: pointer;
  transition: background 0.2s;
  height: 40px;
}

.option-item:hover {
  background: #f5f5f5;
}

.checkbox {
  width: 16px;
  height: 16px;
  /* border: 2px solid #C4C4C4; */
  border-radius: 4px;
  margin-right: 12px;
  position: relative;
  transition: all 0.2s;
}

.checkbox.checked {
  border-color: #214fff;
  color: #214fff;
}

.checkbox.checked::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 8px;
  height: 5px;
  border-left: 2px solid #214fff;
  border-bottom: 2px solid #214fff;
  transform: translate(-50%, -60%) rotate(-45deg);
}

.option-text {
  color: #1f2120;
  font-family: Effra;
}

.empty-message {
  padding: 8px 12px;
  color: #9e9e9e;
  font-size: 14px;
  text-align: center;
}

.filter__disabled {
  opacity: 0.5;
  pointer-events: none;
}
img {
  margin-left: 8px;
}

.option-item.selected:not(.last-selected) {
  border-bottom: none;
}
.option-item.last-selected {
  border-bottom: 0.5px solid #e0e0e0;
}

.divider {
  display: none;
}
.x-close {
  position: absolute;
  right: 7px;
  top: 42%;
  transform: translateY(-50%);
  cursor: pointer;
  width: 19px;
  height: 19px;
}
</style>
